/** A game's name as a file name: letters, digits and dashes, "Hexe Grüne!" becoming "hexe-grune". */
export function fileName(name: string): string {
  return name
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
}
